import {getField, updateField} from 'vuex-map-fields';
import HistoryModule from '@/commonFunction/consumerModule'

let current_module = new HistoryModule('/ws/history/history/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'UUID', value: 'uid', sortable: true, filterable: true, divider: true,},
        {text: 'Version', value: 'version', sortable: true, filterable: true, divider: true,},
        {text: 'Source UUID', value: 'source_uid', sortable: true, filterable: true, divider: true,},
        {text: 'Source name', value: 'source_name', sortable: true, filterable: true, divider: true,},
        {text: 'Source version', value: 'source_version', sortable: true, filterable: true, divider: true,},
        {text: 'Item hash', value: 'item_hash', sortable: true, filterable: true, divider: true,},

        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true,},
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true,},
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime',},
    ],
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        HistoryTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}